import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Alert, Button, Checkbox, FormControlLabel, Icon, Spacer, Stack, Tooltip, Typography } from '@emburse/embark-core';
import { CheckIcon } from '@emburse/embark-icons';
import ERPGatewayPendingExportsDataGrid from './ERPGatewayPendingExportsDataGrid';
import ERPGatewayModal from '../../../components/ERPGateway/components/ERPGatewayModal';
import { $t, useTranslation } from '../../../hooks/useTranslation';
import { useERPGatewayExport } from '../../../components/ERPGateway/ERPGatewayExportProvider';
function ERPGatewayPendingExports({ isActiveStatus, isSyncPending, data }) {
    useTranslation();
    const { markAsExported, selectedRows } = useERPGatewayExport();
    const defaultModalProps = useMemo(() => ({
        onConfirm: () => { },
        onClose: () => { },
        open: false,
        header: 'Confirmation',
        body: _jsx("span", {}),
        confirmButtonText: 'OK',
        showCancel: false
    }), []);
    const [modalProps, setModalProps] = useState(defaultModalProps);
    const setLocalStoragePendingExports = (val) => {
        localStorage.setItem('doNotShowERPPendingExportsAgain', val.toString());
    };
    const getLocalStoragePendingExports = () => {
        return localStorage.getItem('doNotShowERPPendingExportsAgain') === 'true';
    };
    const confirmModalBody = useMemo(() => {
        return (_jsxs(_Fragment, { children: [_jsx(Typography, { children: $t('The selected reports will be removed from this pending exports queue and will not be exported during the next scheduled export. Do you wish to continue?') }), !getLocalStoragePendingExports() && (_jsxs(_Fragment, { children: [_jsx(Spacer, { size: 20 }), _jsx(FormControlLabel, { control: _jsx(Checkbox, { id: "DoNotShowAgain", color: "primary", onChange: (e) => setLocalStoragePendingExports(e.target.checked) }), label: $t('Do not ask me again') })] }))] }));
    }, []);
    const setConfirmModal = (id) => {
        setModalProps({
            onConfirm: () => {
                markAsExported(id);
                setModalProps(defaultModalProps);
            },
            onClose: () => setModalProps(defaultModalProps),
            open: true,
            header: 'Confirmation',
            body: confirmModalBody,
            confirmButtonText: 'OK',
            showCancel: false
        });
    };
    const checkLocalStorageAndDecide = (id) => {
        if (getLocalStoragePendingExports()) {
            markAsExported(id);
        }
        else {
            setConfirmModal(id);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(ERPGatewayModal, { ...modalProps }), _jsxs(Alert, { severity: "info", style: { width: 'fit-content' }, children: [$t('The expense reports below will be exported during the next scheduled or manual export. Select '), _jsx("strong", { children: $t('Mark as Exported') }), $t(' on some or all of the reports below if they should not be exported. To make changes to your export schedule, or to initiate a manual export, open the '), _jsx("strong", { children: $t('Schedule') }), $t(' drawer above.')] }), _jsx(Spacer, { size: 40 }), _jsx(Stack, { spacing: 2, direction: "row", alignItems: "center", justifyContent: "flex-end", children: _jsx(Tooltip, { title: $t('The selected reports will be excluded from future exports and will be removed from this queue'), placement: "top", children: _jsx(Button, { variant: "text", size: "small", startIcon: _jsx(Icon, { iconUrl: CheckIcon }), onClick: () => checkLocalStorageAndDecide(), disabled: !selectedRows.length || isSyncPending, children: $t('Mark As Exported') }) }) }), _jsx(Spacer, { size: 40 }), _jsx(ERPGatewayPendingExportsDataGrid, { data: data, isActiveStatus: isActiveStatus, isSyncPending: isSyncPending, onExport: checkLocalStorageAndDecide })] }));
}
export default ERPGatewayPendingExports;
